import { useEffect, useRef, useState } from 'react';
import {
  getUserEarnedSkillsAPI,
  getUserHighlightedSkillsAPI,
  getUserSelfReportedSkillsAPI,
} from './utils/profileSkills';

export function useProfileSkills(username: string, tenant: string) {
  const hasFetchedData = useRef(false);

  const [userEarnedSkillsData, setUserEarnedSkillsData] = useState<any[]>([]);
  const [userEarnedSkillsDataLoaded, setUserEarnedSkillsDataLoaded] =
    useState<boolean>(false);
  const [highlightedSkillsData, setHighlightedSkillsData] = useState<any[]>([]);
  const [highlightedSkillsDataLoaded, setHighlightedSkillsDataLoaded] =
    useState<boolean>(false);
  const [userSelfReportedSkillsData, setUserSelfReportedSkillsData] = useState<
    any[]
  >([]);
  const [
    userSelfReportedSkillsDataLoaded,
    setUserSelfReportedSkillsDataLoaded,
  ] = useState<boolean>(false);

  useEffect(() => {
    if (!hasFetchedData.current) {
      getUserHighlightedSkillsAPI(username, highlightedSkillsCallback);
      getUserSelfReportedSkillsAPI(username, userSelfReportedSkillsCallback);
      getUserEarnedSkillsAPI(username, userEarnedSkillsCallback);
      hasFetchedData.current = true;
    }
  }, []);

  const userEarnedSkillsCallback = (data) => {
    setUserEarnedSkillsData(Array.isArray(data) ? data : []);
    setUserEarnedSkillsDataLoaded(true);
  };
  const highlightedSkillsCallback = (data) => {
    setHighlightedSkillsData(Array.isArray(data) ? data : []);
    setHighlightedSkillsDataLoaded(true);
  };

  const userSelfReportedSkillsCallback = (data) => {
    setUserSelfReportedSkillsData(Array.isArray(data) ? data : []);
    setUserSelfReportedSkillsDataLoaded(true);
  };
  return [
    userEarnedSkillsData as any,
    userEarnedSkillsDataLoaded as any,
    highlightedSkillsData as any,
    highlightedSkillsDataLoaded as any,
    userSelfReportedSkillsData as any,
    userSelfReportedSkillsDataLoaded as any,
    setUserSelfReportedSkillsData,
    setHighlightedSkillsData,
  ];
}
